import $ from 'jquery';

let selectors = {
        signature: '.c-author-photo__text',
        control: '.c-control-gallerey',
    };

function clickPhoto() {

}

function preLoadImgs(mGallery) {
	mGallery.forEach(function(o){
		new Image().src = o.imgSrc;
	});
}

$('.js-gallery').each(function () {
    var $this = $(this),
        $img = $this.find('img'),
        id = this.id,
        params = $this.data('gallery-param'),
        $selectorControl = $(params.selectorControl),
        control = $selectorControl.find(selectors.control),
        btnPrev = $('.js-btn__prev', control),
        btnNext = $('.js-btn__next', control),
        controlText = $('.js-control__title', control),
        currentImg = 0,
        signaturePhoto = $(selectors.signature, $selectorControl),
        signaturePhoto2 = $this.find(selectors.signature);

    if (params.img && params.img.length > 0) {

        setImage();

        btnPrev.on('click', function (e) {
            e.preventDefault();

            if (currentImg === 0) {
                return;
            }
            $this.css('backgroundImage', 'url('+params.img[--currentImg].imgSrc+')');
            setImage();
        });

        btnNext.on('click', function (e) {
            e.preventDefault();

            if ((currentImg + 1) < params.img.length) {

                $this.css('backgroundImage', 'url('+params.img[++currentImg].imgSrc+')');
                setImage();
            }

        });
		preLoadImgs(params.img);
    }

    function setImage() {
        controlText.html(currentImg + 1 + '/' + params.img.length);
        let text = params.img[currentImg].name;
        if(params.img[currentImg].signature.length) {
            text += ` / ${params.img[currentImg].signature}`;
        }
        signaturePhoto.text(text);
        signaturePhoto2.text(text);
    }
});


export default function () {


}


// WEBPACK FOOTER //
// ./modules/photo-gallery.js